<template>
  <div class="aboutBrief">
    <div class="compText">
      盛唐中融保险经纪（深圳）有限公司是中国专业第三方保险服务头部企业之一。依托于自身强大的科技实力和优势资源，现已在北京、河北、深圳、四川、安徽等地开设7家分支机构，并保持高速发展态势。
    </div>
    <div class="compText">
      公司始终以保险人为核心，倾力打造「中国最具亲和力的保险人终身事业平台」，并以“大平台、小前端、富生态、共治理”的理念，打造专业化、精英化、企业化的全新众创平台。在为各类保险自主经营体提供高效赋能的同时，也为更多保险客户提供更加专业、优质、高效、阳光的服务，真正实现「用我们的平台，让保险更简单阳光，成就更多人的幸福」的企业使命。
    </div>
    <div class="compText">
      公司高度聚焦展业诉求，全力构建「科技赋能」、「产品工厂」、「客户引流」、「学习成长」、 「营销支持」和「增值服务」六大赋能体系，迄今累计共建保险事务所 / 家族办公室超300 家，绩优营销员月均产能 6.6
      万元，与行业平均水平相比更具价值力。
    </div>
    <div class="compText">
      公司通过「星火计划」、「鸿鹄计划」、「鲲鹏计划」等一系列行业领先的事业合伙机制，构建“共创”、“共担”、“共赢”的事业共同体。可观的即期佣金收入、中期盈利分润和远期股权合伙，成就更多保险梦想，共筑保险事业长青！
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutBrief',
  components: {},
  data() {
    return {}
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../styles/face";

.aboutBrief {
  width: 1024px;
  margin: 0 auto;

  .middle {
    display: flex;
    justify-content: center;
    padding: 60px 0;

    .left {
      border-radius: 60px 0px 0px 0px;
      margin-right: 100px;
    }

    .right {
      border-radius: 0px 60px 0px 0px;

      img {
        width: 40px;
        margin-right: 30px;
      }
    }

    .spacial {
      font-family: 'number-special' !important;
    }

    &>div {
      color: #FE7B27;
      background-color: #FBF1EA;
      width: 311px;
      height: 106px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 50px;
        margin-right: 30px;
      }
    }
  }
}
</style>
